import React, { Component, Fragment } from "react";

import "./WebViewExtension.css";

export const WEB_VIEW_EXT_ID = "WEB_VIEW";

export default class WebViewExtension extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // bottomMargin: 0,
      popUpHeight: 0,
      title: props.webview.title,
      url: props.webview.url,
      height: props.webview.height,
      hideHeader: this.props.isSuggestBot ? false : props.webview.largeWindowHideHeader,
    };


    // Resize box to sit above input
    this.findInputTimerId = setInterval(() => {
      let chatbox = document.getElementById("chat_box");

      if (!chatbox) {
        return;
      }

      let inputs = chatbox.querySelectorAll("input");
      let inputRegion = chatbox.querySelectorAll("[role='form']");

      if (inputs.length < 1 || inputRegion.length < 1) {
        return;
      }

      let popUp = document.getElementsByClassName("chat_popup booking_popup");

      if (popUp.length) {
        this.setState({
          popUpHeight: popUp[0].clientHeight,
        });
      }

      // this.setState({
      //     bottomMargin: inputRegion[0].clientHeight
      // });

      clearInterval(this.findInputTimerId);
    }, 50);

    this.close = this.close.bind(this);
    window.addEventListener("message", this.windowMessage.bind(this), false);
  }

  componentDidMount() {
    var params = this.props.webview.url.split("?")[1].split("&");
    var data = {};
    for (var x in params) {
      data[params[x].split("=")[0]] = decodeURIComponent(params[x].split("=")[1]);
    }
    if (data.default_form === "1") {
      fetch(
        `${process.env.REACT_APP_BFF_API}/public/forms/get/${data.id}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => response.json())
        .then((json) => {
          var form = json;
          this.setState({ title: form.name });
        });
    }
  }

  componentDidUpdate(oldProps) {
    if (!this.props.webview) {
      return;
    }

    if (
      !oldProps.webview ||
      oldProps.webview.title !== this.props.webview.title ||
      oldProps.webview.url !== this.props.webview.url ||
      oldProps.webview.height !== this.props.webview.height ||
      oldProps.webview.largeWindowHideHeader !==
      this.props.webview.largeWindowHideHeader
    ) {
      this.setState({
        title: this.props.webview.title,
        url: this.props.webview.url,
        height: this.props.webview.height,
        hideHeader: this.props.isSuggestBot ? false : this.props.webview.largeWindowHideHeader,
      });
    }
  }

  windowMessage(event) {
    if (event.data === "closeDefaultForm") {
      this.close();
    }
  }

  close() {
    this.setState({
      closing: true,
      title: "",
      url: "",
      height: "",
    });
    // Allow animation to play
    setTimeout(() => {
      this.setState({
        closing: false,
      });

      this.props.api.setExtension(WEB_VIEW_EXT_ID, undefined);
    }, 800);
  }

  render() {
    const color = this.props.styling;
    // console.log('12', this.props.messenger === true,
    //   this.state.hideHeader !== undefined && this.state.hideHeader === true)
    var height = "calc(-105px + 100vh)";
    let containerStyling = {
      // bottom: this.state.bottomMargin,
      // height: 'calc(' + this.state.height + '% - ' + (this.state.bottomMargin + this.state.popUpHeight) + 'px)',
      height: this.props.messenger === true ?
        this.state.hideHeader !== undefined && this.state.hideHeader === true ? "calc(100vh - 1px)" : "calc(100vh - 55px)" : "calc(" + this.state.height + "% - " + 0 + "px)",
      animationName: this.state.closing ? "slide-down" : "slide-up",
      top: this.props.messenger === true ?
        this.state.hideHeader !== undefined && this.state.hideHeader === true ? "0px" : "20px" : "",
      padding: this.props.messenger === true ?
        this.state.hideHeader !== undefined && this.state.hideHeader === true ? "0px" : "8px" : ""

    };
    if (this.props.isSuggestBot) {
      containerStyling.height = height;
      containerStyling.top = "0px";
      containerStyling.topaddingp = "0px";
      containerStyling.width = "400px";
      containerStyling.right = "30%";
      containerStyling.left = "40%";
    }
    return this.state.url !== "" && (
      <div className="web-view-container-set" style={containerStyling}>
        {this.state.hideHeader !== undefined &&
          this.state.hideHeader === true ? (
          <div className="web-view-close-chatbox-set" onClick={this.close}>
            <img src="/res/cross_icon.jpg" width="15" height="15" />
            {/* <svg
              style={{
                fill:
                  this.state.url.indexOf("/room?") > 0
                    ? "white"
                    : color.colours.headerText || "black",
              }}
              className="web-view-close-svg"
            >
              <use xlinkHref="/res/defs.svg#svg-icon-cross"></use>
            </svg> */}
          </div>
        ) : (
          <Fragment>
            {this.state.url.includes("form-view") ?
              <div className="web-view-close-form-set" onClick={this.close}>
                {this.state.url.includes("default_form=1") &&
                  <span className="truncate">{this.state.title}</span>
                }
                <img src="/res/cross_icon.jpg" width="15" height="15" />
              </div>
              :
              <div
                className="web-view-header-set"
                style={{
                  // backgroundColor: color.colours.header,
                  color: color.colours.headerText,
                }}
              >
                {/* <span className="truncate"> {this.state.title} </span> */}
                <div className="web-view-close" onClick={this.close}>
                  {/* <svg
                style={{ fill: color.colours.headerText || "black" }}
                className="web-view-close-svg"
              >
                <use xlinkHref="/res/defs.svg#svg-icon-times"></use>
              </svg> */}
                  <img src="/res/cross_icon.jpg" width="15" height="15" />
                </div>
              </div>
            }
          </Fragment>
        )}
        <div className="web-view-inner-container">
          <iframe
            id="webviewframe"
            src={this.state.url}
            title="Chat Web View"
            className="web-view-frame"
          />
        </div>
      </div>
    );
  }
}
